/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_ModeInputs */

const cs_billing_mode = /** @type {(inputs: Billing_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Režim fakturace`)
};

const en_billing_mode = /** @type {(inputs: Billing_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing mode`)
};

/**
* | output |
* | --- |
* | "Billing mode" |
*
* @param {Billing_ModeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_mode = /** @type {((inputs?: Billing_ModeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_ModeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_mode(inputs)
	return cs_billing_mode(inputs)
});